import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import { useParams } from "react-router-dom";
import '../css/ViewRequisition.css';
import Sidebar from './Sidebar';
import PopupModal from "./PopupModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";
import ExportExcelButton from './ExportExcelButton';

const ViewRequisition = () => {
  const navigate = useNavigate();
  const [showHistory, setShowHistory] = useState(false);
  const [history, setHistory] = useState({ audits: [], reviews: [] });
  const [combinedHistory, setCombinedHistory] = useState([]);
  const { requisitionID } = useParams(); 
  const [requisition, setRequisition] = useState(null);
  const signatureFilePath = localStorage.getItem("signatureFilePath");
  const fullName = localStorage.getItem('fullName'); 
  const [submitter, setSubmitter] = useState(null);
  const contentRef = useRef();
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);

  // State variables needed for ExportExcelButton
  const [formArray, setFormArray] = useState([]);
  const [costItems, setCostItems] = useState([]);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchRequisitionDetails = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisitionID}`);
        const requisitionData = response.data;
        setRequisition(requisitionData);
        
        // Set formData for ExportExcelButton - INCLUDING DISTRICT AND AREA PROGRAM PAIRS
        setFormData({
          staffName: requisitionData.staffName,
          staffLevel: requisitionData.staffLevel,
          supervisorName: requisitionData.supervisorName,
          activityName: requisitionData.activityName,
          activityPurpose: requisitionData.activityPurpose,
          from: requisitionData.from,
          to: requisitionData.to,
          targetClient: requisitionData.targetClient,
          expectedImpact: requisitionData.expectedImpact,
          projectCode: requisitionData.projectCode,
          budgetLineCode: requisitionData.budgetLineCode,
          projectName: requisitionData.projectName,
          payMode: requisitionData.payMode,
          bankName: requisitionData.bankName,
          branch: requisitionData.branch,
          accountNumber: requisitionData.accountNumber,
          phoneNumber: requisitionData.phoneNumber,
          requisitionDate: requisitionData.requisitionDate,
          requisitionID: requisitionData.requisitionID,
          status: requisitionData.status,
          // ADD DISTRICT AND AREA PROGRAM PAIRS HERE
          districtAndAreaProgramPairs: requisitionData.districtAndAreaProgramPairs || []
        });

        // Set costItems for ExportExcelButton
        if (requisitionData.costDrivers && requisitionData.costDrivers.length > 0) {
          setCostItems(requisitionData.costDrivers.map(driver => ({
            costDriver: driver.costDriver || driver.customCostDriver || '',
            justification: driver.justification || '',
            quantity: driver.quantity || '',
            unitPrice: driver.unitPrice || '',
            total: driver.total || '',
            supportDocuments: driver.supportDocuments || '',
            isCustom: !!driver.customCostDriver,
            customCostDriver: driver.customCostDriver || ''
          })));
        }

        // Fetch submitter details using the userID from requisition
        if (requisitionData.userID) {
          try {
            const submitterResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/users/${requisitionData.userID}`,
              {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
              }
            );
            setSubmitter(submitterResponse.data);
          } catch (error) {
            console.error('Error fetching submitter details:', error);
          }
        }

      } catch (error) {
        console.error('Error fetching requisition details:', error);
      }
    };
    
    fetchRequisitionDetails();
  }, [requisitionID]);

  const handleSurrender = (requisitionID) => {
    navigate(`/surrender/${requisitionID}`);
  };

  // Fixed getStatusClass with null/undefined checks
  const getStatusClass = (status) => {
    if (!status) return ""; // Handle undefined/null status
    
    if (status === "Draft") return "status-draft"; 
    if (status === "Submitted") return "status-submitted";
    if (status === "Surrender Submitted") return "status-surrender-submitted";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    if (status === "Approved") return "status-approved";
    if (status === "Surrender Approved") return "status-surrender-approved";
    if (status === "Disapproved") return "status-disapproved"; 
    if (status === "Disbursed") return "status-disbursed"; 
    if (status === "To be disbursed") return "status-to-be-disbursed"; 
    return ""; 
  };

  const fetchHistory = async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/history`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      const audits = Array.isArray(data.audits)
        ? data.audits
        : data.audits?.$values || [];
  
      const reviews = Array.isArray(data.reviews)
        ? data.reviews
        : data.reviews?.$values || [];
  
      setHistory({ audits, reviews });
      
      // Fixed combined history with null checks
      const combined = reviews.map((r, i) => ({
        step: r.step || 0,
        reviewer: r.by || "",
        reviewedAt: r.at || "",
        status: audits[i]?.newValue || ""      
      }));

      setCombinedHistory(combined);
      setShowHistory(true);
    } catch (err) {
      console.error("Failed to load history", err);
    }
  };
  
 const formatDate = iso => {
  if (!iso) return 'N/A';
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", {
    day:   "2-digit",
    month: "short",
    year:  "numeric"
  }); // This will give "15 Nov 2024"
};
  const formatTime = iso => {
    if (!iso) return 'N/A';
    const d = new Date(iso);
    return d.toLocaleTimeString("en-US", {
      hour:   "numeric",
      minute: "numeric"  
    });
  };

  const formatDateTimeHarare = iso => {
    if (!iso) return 'N/A';
    return new Intl.DateTimeFormat("en-GB", {
      day:     "numeric",
      month:   "long",
      year:    "numeric",
      hour:    "numeric",
      minute:  "numeric",
      hour12:  true,
      timeZone: "Africa/Harare"
    }).format(new Date(iso));
  };

const handlePrint = () => {
  setIsPreparingPrint(true);
  
  const content = document.getElementById('printable-area');
  if (!content) {
      console.error('Print target not found: printable-area');
      setIsPreparingPrint(false);
      return;
  }

  // ADAPTED: Extract data from text content instead of form inputs
  const extractDataFromContent = () => {
      const data = {};
      
      console.log('=== DEBUG: STARTING CONTENT DATA EXTRACTION ===');
      
      // Extract data from text content using CSS selectors and text parsing
      const selectors = {
          staffName: '.form-group-review-requisition p:contains("Staff Name:")',
          staffLevel: '.form-group-review-requisition p:contains("Staff Level:")',
          supervisorName: '.form-group-review-requisition p:contains("Supervisor Name:")',
          activityName: '.form-group-review-requisition p:contains("Activity Name:")',
          activityPurpose: '.form-group-review-requisition p:contains("Activity Purpose:")',
          targetClient: '.form-group-review-requisition p:contains("Target Client:")',
          expectedImpact: '.form-group-review-requisition p:contains("Expected Impact:")',
          projectCode: '.form-group-review-requisition p:contains("Project Code:")',
          budgetLineCode: '.form-group-review-requisition p:contains("Budget Line Code:")',
          projectName: '.form-group-review-requisition p:contains("Project Name:")',
          payMode: '.form-group-review-requisition p:contains("Pay Mode:")',
          bankName: '.form-group-review-requisition p:contains("Bank Name:")',
          branch: '.form-group-review-requisition p:contains("Branch:")',
          accountNumber: '.form-group-review-requisition p:contains("Account Number:")',
          phoneNumber: '.form-group-review-requisition p:contains("Phone Number:")'
      };

      // Extract data from paragraphs by finding the element and getting the text after the label
      Object.keys(selectors).forEach(key => {
          // Find all paragraphs and look for the ones containing our labels
          const paragraphs = content.querySelectorAll('p');
          paragraphs.forEach(p => {
              const text = p.textContent || '';
              if (text.includes(selectors[key].split(':contains("')[1].replace('")', ''))) {
                  // Extract the value after the label
                  const value = text.split(':').slice(1).join(':').trim();
                  if (value && value !== 'N/A') {
                      data[key] = value;
                      console.log(`Found ${key}:`, value);
                  }
              }
          });
      });

      // Extract dates from the requisition date section
      const dateSection = content.querySelector('.view-requisition-date-and-id');
      if (dateSection) {
          const paragraphs = dateSection.querySelectorAll('p');
          paragraphs.forEach(p => {
              const text = p.textContent || '';
              if (text.includes('Requisition Date:')) {
                  data.requisitionDate = text.split('Requisition Date:')[1].trim();
              }
              if (text.includes('Requisition ID:')) {
                  data.requisitionID = text.split('Requisition ID:')[1].trim();
              }
          });
      }

      // Extract from and to dates
      const activitySection = content.querySelector('.form-group-review-requisition');
      if (activitySection) {
          const paragraphs = activitySection.querySelectorAll('p');
          paragraphs.forEach(p => {
              const text = p.textContent || '';
              if (text.includes('From:')) {
                  data.from = text.split('From:')[1].split('To:')[0].trim();
              }
              if (text.includes('To:')) {
                  const toParts = text.split('To:');
                  if (toParts.length > 1) {
                      data.to = toParts[1].split('Activity Name:')[0].trim();
                  }
              }
          });
      }

      return data;
  };

  const formData = extractDataFromContent();
  console.log('Content data collected:', formData);

  // Use the actual requisition data from state instead of trying to extract from DOM
  const requisitionID = requisition?.requisitionID || 'Draft';
  const requisitionDate = requisition?.requisitionDate ? formatDate(requisition.requisitionDate) : new Date().toLocaleDateString();
  const status = requisition?.status || 'Draft';
  const staffName = requisition?.staffName || '';

  console.log('=== FINAL EXTRACTED VALUES ===');
  console.log('Requisition ID:', requisitionID);
  console.log('Requisition Date:', requisitionDate);
  console.log('Status:', status);
  console.log('Staff Name:', staffName);
  
  const printWindow = window.open('', '_blank', 'width=1000,height=800');
  
  // Show loading message in print window
  printWindow.document.write(`
      <html>
      <head>
          <title>Preparing to Print...</title>
          <style>
              body { 
                  font-family: Arial, sans-serif; 
                  display: flex; 
                  justify-content: center; 
                  align-items: center; 
                  height: 100vh; 
                  background: #f5f5f5;
                  margin: 0;
              }
              .loading {
                  text-align: center;
                  padding: 30px;
                  background: white;
                  border-radius: 8px;
                  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .spinner {
                  border: 4px solid #f3f3f3;
                  border-top: 4px solid #3498db;
                  border-radius: 50%;
                  width: 50px;
                  height: 50px;
                  animation: spin 1s linear infinite;
                  margin: 0 auto 20px;
              }
              @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
              }
              .loading-text {
                  font-size: 16px;
                  color: #333;
              }
          </style>
      </head>
      <body>
          <div class="loading">
              <div class="spinner"></div>
              <div class="loading-text">Preparing document for printing...</div>
          </div>
      </body>
      </html>
  `);
  printWindow.document.close();

  // Use setTimeout to ensure the loading screen is displayed
  setTimeout(() => {
      // Use the actual cost drivers from state - SEPARATE BLASTING AND OTHER
      const blastingCostDrivers = requisition?.blastingCostDrivers?.map(driver => ({
          costDriver: driver.costDriver || driver.customCostDriver || '',
          justification: driver.justification || '',
          quantity: driver.quantity || '0',
          unitPrice: driver.unitPrice || '0',
          total: driver.total || '0',
          supportDocuments: driver.supportDocuments || ''
      })) || [];

      const otherCostDrivers = requisition?.costDrivers?.map(driver => ({
          costDriver: driver.costDriver || driver.customCostDriver || '',
          justification: driver.justification || '',
          quantity: driver.quantity || '0',
          unitPrice: driver.unitPrice || '0',
          total: driver.total || '0',
          supportDocuments: driver.supportDocuments || ''
      })) || [];

      // Use the actual district pairs from state
      const districtPairs = requisition?.districtAndAreaProgramPairs?.map(pair => ({
          district: pair.district || '',
          areaProgram: pair.areaProgram || ''
      })) || [];

      // Use the actual signature from state
      const signatureImageUrl = submitter?.signatureFilePath 
          ? `${process.env.REACT_APP_STATIC_BASE_URL}/${submitter.signatureFilePath}`
          : null;

      // Use the actual form data from state instead of extracted data
      const printFormData = {
          staffName: requisition?.staffName || '',
          staffLevel: requisition?.staffLevel || '',
          supervisorName: requisition?.supervisorName || '',
          activityName: requisition?.activityName || '',
          activityPurpose: requisition?.activityPurpose || '',
          from: requisition?.from ? formatDate(requisition.from) : '',
          to: requisition?.to ? formatDate(requisition.to) : '',
          targetClient: requisition?.targetClient || '',
          expectedImpact: requisition?.expectedImpact || '',
          projectCode: requisition?.projectCode || '',
          budgetLineCode: requisition?.budgetLineCode || '',
          projectName: requisition?.projectName || '',
          payMode: requisition?.payMode || '',
          bankName: requisition?.bankName || '',
          branch: requisition?.branch || '',
          accountNumber: requisition?.accountNumber || '',
          phoneNumber: requisition?.phoneNumber || ''
      };

      // Calculate totals
      const blastingTotal = blastingCostDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0);
      const otherTotal = otherCostDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0);
      const grandTotal = blastingTotal + otherTotal;

      printWindow.document.open();
      printWindow.document.write(`
          <html>
          <head>
              <title>Requisition Form - ${requisitionID}</title>
              <style>
              @page {
                  margin: 0;
                  size: auto;
              }

              @page :header {
                  display: none !important;
              }

              @page :footer {
                  display: none !important;
              }
                  * {
                      margin: 0;
                      padding: 0;
                      box-sizing: border-box;
                  }
                  
                  body {
                      font-family: 'Arial', sans-serif;
                      font-size: 12px;
                      line-height: 1.4;
                      color: #000;
                      padding: 20px 25px;
                      background: white;
                  }
                  
                  .print-header {
                      text-align: center;
                      margin-bottom: 2px;
                      padding-bottom: 2px;
                      border-bottom: 2px solid #333;
                  }
                  
                  .print-header h1 {
                      font-size: 22px;
                      margin-bottom: 2px;
                      color: #2c3e50;
                      text-transform: uppercase;
                      letter-spacing: 1px;
                  }
                  
                  .print-meta {
                      display: flex;
                      justify-content: space-between;
                      font-size: 12px;
                      margin-bottom: 2px;
                      flex-wrap: wrap;
                      gap: 15px;
                  }
                  
                  .meta-item {
                      display: flex;
                      flex-direction: column;
                  }
                  
                  .meta-label {
                      font-weight: bold;
                      color: #555;
                      margin-bottom: 0px;
                  }
                  
                  .info-columns {
                      display: grid;
                      grid-template-columns: repeat(3, 1fr);
                      gap: 20px;
                      margin-bottom: 3px;
                  }
                  
                  .info-column {
                      background: #f8f9fa;
                      padding: 18px;
                      border-radius: 6px;
                      border: 1px solid #e9ecef;
                      height: fit-content;
                  }
                  
                  .info-column h4 {
                      margin-bottom: 5px;
                      color: #495057;
                      border-bottom: 2px solid #007bff;
                      padding-bottom: 8px;
                      font-size: 14px;
                      text-transform: uppercase;
                      font-weight: bold;
                  }
                  
                  .form-field {
                      margin-bottom: 2px;
                  }
                  
                  .form-field label {
                      display: block;
                      font-weight: bold;
                      font-size: 11px;
                      margin-bottom: 4px;
                      color: #555;
                      text-transform: uppercase;
                  }
                  
                  .form-field .field-value {
                      padding: 8px 10px;
                      border: 1px solid #ddd;
                      border-radius: 4px;
                      background: white;
                      min-height: 35px;
                      display: flex;
                      align-items: center;
                      word-break: break-word;
                      font-size: 11px;
                  }
                  
                  .empty-field {
                      color: #999;
                      font-style: italic;
                  }
                  
                  
                  
                  .print-table th {
                      background-color: #2c3e50;
                      color: black;
                      padding: 5px 6px;
                      text-align: left;
                      font-weight: bold;
                      border: 1px solid #444;
                      font-size: 11px;
                      text-transform: uppercase;
                  }
                  
                  .print-table td {
                      padding: 4px 6px;
                      border: 1px solid #ddd;
                      vertical-align: top;
                  }
                  
                  .print-table tfoot td {
                      background-color: #e9ecef;
                      font-weight: bold;
                      border-top: 2px solid #333;
                      font-size: 11px;
                  }
                  
                  .cost-driver-table {
                      font-size: 9px;
                  }
                  
                  .cost-driver-table td {
                      max-width: 180px;
                      overflow-wrap: break-word;
                  }
                  
                  .cost-driver-table .justification-cell {
                      max-width: 250px;
                  }

                  .print-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 10px 0;
                        font-size: 10px;
                        page-break-inside: avoid;
                    }

                    .section-heading {
                        font-size: 14px;
                        font-weight: bold;
                        margin: 12px 0 6px 0;
                        color: #2c3e50;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 5px;
                    }
                
                 .signature-section {
                      margin-top: 0;
                      padding-top: 0;
                      text-align: center;
                      width: 100%;
                  }

                 .signature-container {
                    display: inline-block;
                    text-align: center;
                    margin: 0 auto;
                    padding: 2px 20px;
                }

                 .signed-by-label {
                      font-size: 11px;
                      margin-bottom: 2px;
                      color: #666;
                      text-transform: none !important;
                  }

                 .signature-image {
                      max-width: 120px !important;
                      max-height: 40px !important;
                      border-bottom: 1px solid #000;
                      margin: 0 auto 1px auto;
                      display: block;
                  }

                  .signature-line {
                      height: 1px;
                      border-bottom: 1px solid #000;
                      margin: 0 auto 4px auto;
                      width: 150px;
                  }

                  .user-full-name {
                      font-weight: bold;
                      margin-top: 3px;
                      font-size: 11px;
                      text-transform: none !important;
                  }
                      
                  .grand-total-print {
                      text-align: right;
                      font-weight: bold;
                      font-size: 14px;
                      margin-top: 15px;
                      padding: 10px;
                      background-color: #f8f9fa;
                      border: 1px solid #ddd;
                      border-radius: 4px;
                  }
              </style>
          </head>
          <body>
              <div class="print-header">
                  <h1>REQUISITION FORM</h1>
                  <div class="print-meta">
                      <div class="meta-item">
                          <span class="meta-label">Requisition ID:</span>
                          <span>${requisitionID}</span>
                      </div>
                      <div class="meta-item">
                          <span class="meta-label">Requisition Date:</span>
                          <span>${requisitionDate}</span>
                      </div>
                      <div class="meta-item">
                          <span class="meta-label">Status:</span>
                          <span>${status}</span>
                      </div>
                  </div>
              </div>

              <div class="info-columns">
                  <!-- Staff Information Column -->
                  <div class="info-column">
                      <h4>Staff Details</h4>
                      <div class="form-field">
                          <label>Staff Name:</label>
                          <div class="field-value">${printFormData.staffName || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Staff Level:</label>
                          <div class="field-value">${printFormData.staffLevel || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Supervisor Name:</label>
                          <div class="field-value">${printFormData.supervisorName || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                  </div>
                  
                  <!-- Activity Information Column -->
                  <div class="info-column">
                      <h4>Activity Details</h4>
                       <div class="form-field">
                        <label>Activity Duration:</label>
                        <div class="field-value" style="padding: 4px 6px;">
                            ${printFormData.from ? printFormData.from.replace(/ /g, ' ') : 'Not provided'} 
                            &nbsp;to&nbsp; 
                            ${printFormData.to ? printFormData.to.replace(/ /g, ' ') : 'Not provided'}
                        </div>
                    </div>
                    
                      <div class="form-field">
                          <label>Activity Name:</label>
                          <div class="field-value">${printFormData.activityName || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Activity Purpose:</label>
                          <div class="field-value">${printFormData.activityPurpose || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Target Client:</label>
                          <div class="field-value">${printFormData.targetClient || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Expected Impact:</label>
                          <div class="field-value">${printFormData.expectedImpact || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      
                      <!-- DISTRICT & AREA PROGRAM PAIRS -->
                      <div class="form-field">
                          <label>District & Area Program:</label>
                          <div class="field-value" style="padding: 10px; background: #f8f9fa; border-radius: 4px;">
                              ${districtPairs.length > 0 ? `
                              <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                                  <thead>
                                      <tr>
                                          <th style="text-align: left; padding: 4px;">#</th>
                                          <th style="text-align: left; padding: 4px;">District</th>
                                          <th style="text-align: left; padding: 4px;">Area Program</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      ${districtPairs.map((pair, index) => `
                                          <tr>
                                              <td style="padding: 4px; border-bottom: 1px solid #eee;">${index + 1}</td>
                                              <td style="padding: 4px; border-bottom: 1px solid #eee;">${pair.district || 'Not specified'}</td>
                                              <td style="padding: 4px; border-bottom: 1px solid #eee;">${pair.areaProgram || 'Not specified'}</td>
                                          </tr>
                                      `).join('')}
                                  </tbody>
                              </table>
                          ` : '<span class="empty-field">Not provided</span>'}

                          </div>
                      </div>
                  </div>
                  
                  <!-- Project Information Column -->
                  <div class="info-column">
                      <h4>Project Details</h4>
                      <div class="form-field">
                          <label>Project Code:</label>
                          <div class="field-value">${printFormData.projectCode || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Project Name:</label>
                          <div class="field-value">${printFormData.projectName || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Budget Line Code:</label>
                          <div class="field-value">${printFormData.budgetLineCode || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Pay Mode:</label>
                          <div class="field-value">${printFormData.payMode || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Bank Name:</label>
                          <div class="field-value">${printFormData.bankName || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Branch:</label>
                          <div class="field-value">${printFormData.branch || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                      <div class="form-field">
                          <label>Account Number:</label>
                          <div class="field-value">${printFormData.accountNumber || '<span class="empty-field">Not provided</span>'}</div>
                      </div>
                  </div>
              </div>

              <!-- Blasting Cost Drivers Section -->
              <div class="section-heading">BLASTING COST DRIVERS</div>                
              ${blastingCostDrivers.length > 0 ? `
                  <table class="print-table cost-driver-table">
                      <thead>
                          <tr>
                              <th>#</th>
                              <th>Cost Driver</th>
                              <th>Justification</th>
                              <th>Quantity</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                              <th>Support Documents</th>
                          </tr>
                      </thead>
                      <tbody>
                          ${blastingCostDrivers.map((driver, index) => `
                              <tr>
                                  <td>${index + 1}</td>
                                  <td>${driver.costDriver || '<span class="empty-field">Not specified</span>'}</td>
                                  <td class="justification-cell">${driver.justification || '<span class="empty-field">Not provided</span>'}</td>
                                  <td>${driver.quantity || '0'}</td>
                                  <td>${driver.unitPrice || '0'}</td>
                                  <td>${driver.total || '0'}</td>
                                  <td>${driver.supportDocuments || '<span class="empty-field">Not specified</span>'}</td>
                              </tr>
                          `).join('')}
                      </tbody>
                      <tfoot>
                          <tr>
                              <td colspan="5" style="text-align: right;"><strong>Blasting Total:</strong></td>
                              <td><strong>${blastingTotal.toLocaleString()}</strong></td>
                              <td></td>
                          </tr>
                      </tfoot>
                  </table>
              ` : '<p class="empty-field">No blasting cost drivers</p>'}

              <!-- Other Cost Drivers Section -->
              <div class="section-heading">OTHER COST DRIVERS</div>                
              ${otherCostDrivers.length > 0 ? `
                  <table class="print-table cost-driver-table">
                      <thead>
                          <tr>
                              <th>#</th>
                              <th>Cost Driver</th>
                              <th>Justification</th>
                              <th>Quantity</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                              <th>Support Documents</th>
                          </tr>
                      </thead>
                      <tbody>
                          ${otherCostDrivers.map((driver, index) => `
                              <tr>
                                  <td>${index + 1}</td>
                                  <td>${driver.costDriver || '<span class="empty-field">Not specified</span>'}</td>
                                  <td class="justification-cell">${driver.justification || '<span class="empty-field">Not provided</span>'}</td>
                                  <td>${driver.quantity || '0'}</td>
                                  <td>${driver.unitPrice || '0'}</td>
                                  <td>${driver.total || '0'}</td>
                                  <td>${driver.supportDocuments || '<span class="empty-field">Not specified</span>'}</td>
                              </tr>
                          `).join('')}
                      </tbody>
                      <tfoot>
                          <tr>
                              <td colspan="5" style="text-align: right;"><strong>Other Cost Total:</strong></td>
                              <td><strong>${otherTotal.toLocaleString()}</strong></td>
                              <td></td>
                          </tr>
                      </tfoot>
                  </table>
              ` : '<p class="empty-field">No other cost drivers</p>'}

              <!-- Grand Total -->
              ${(blastingCostDrivers.length > 0 || otherCostDrivers.length > 0) ? `
                  <div class="grand-total-print">
                      Blasting Cost Drivers Total: ${blastingTotal.toLocaleString()} &nbsp;|&nbsp; Other Cost Drivers Total: ${otherTotal.toLocaleString()} &nbsp;|&nbsp; 
                      <strong>Grand Total: ${grandTotal.toLocaleString()}</strong>
                  </div>
              ` : ''}

              <!-- Signature Section -->
              <div class="signature-section">
                  <div class="signature-container">
                      <div class="signed-by-label">Signed by:</div>
                      ${signatureImageUrl ? `
                          <img src="${signatureImageUrl}" alt="Signature" class="signature-image" />
                      ` : `
                          <div style="height: 1px; border-bottom: 1px solid #000; margin: 0 auto 1px auto; width: 150px;"></div>
                      `}
                      <div class="user-full-name">${staffName}</div>
                      <div style="font-size: 10px; color: #666; margin-top: 1px;">${requisitionDate}</div>
                  </div>
              </div>
          </body>
          </html>
      `);
      
      printWindow.document.close();
      
      // Wait for content to render completely before printing
      setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          
          // Close the window after printing
          setTimeout(() => {
              printWindow.close();
              setIsPreparingPrint(false);
          }, 1000);
          
      }, 2000);
      
  }, 1000);
};

  // Show loading state while requisition is being fetched
  if (!requisition) {
    return (
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
              {/* Topbar content */}
            </nav>
            <div className="container-fluid">
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Loading requisition details...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div id="wrapper">
      <Sidebar />

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            {/* Sidebar Toggle */}
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Search */}
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                  aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid">
            {/* Buttons Container - Added Print and ExportExcel buttons */}
            <div className="buttons-container">
              {/* Custom Print Button with the same functionality as PrintButton component */}
              <button 
                className={`the-print-button ${isPreparingPrint ? 'printing' : ''}`} 
                onClick={handlePrint}
                disabled={isPreparingPrint}
                style={{
                    opacity: isPreparingPrint ? 0.7 : 1,
                    cursor: isPreparingPrint ? 'not-allowed' : 'pointer'
                }}
              >
                <i className="fas fa-print"></i> 
                {"Print"}
              </button>
              
              <ExportExcelButton
                formArray={formArray}
                setFormArray={setFormArray}
                currentFormData={formData}
                costItems={costItems} 
                fileName={`Requisition.xlsx`}
              />
            </div>

            {/* Printable area */}
            <div id="printable-area" ref={contentRef} style={{ padding: '20px' }}>
              {/* Rest of your ViewRequisition content remains exactly the same */}
              <div className="view-requisition-container">
                <div className="view-requisition-header">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="nav-link btn p-0"
                    style={{ background: 'none', border: 'none' }}
                  >
                    <i className="fas fa-arrow-left back-button"></i> {/* Back */}
                  </button>
                  <h1 className="h3">Requisition</h1>
                  <div className="view-status-container">
                    <div><strong>Status:</strong></div>
                    <div className={`badge ${getStatusClass(requisition.status)}`}>
                      {requisition.status}
                    </div>
                    {
                      /*
                      <button
                        className="btn btn-outline-secondary"
                        onClick={fetchHistory}
                      >
                        <FontAwesomeIcon icon={faHistory} /> View History
                      </button>
                      */
                    }
                    {requisition.status === "Disbursed" && (
                      <Link to={`/surrender/${requisition.requisitionID}`}>
                        <button
                          className="btn btn-outline-success btn-sm"
                          onClick={() => handleSurrender(requisition.requisitionID)}
                        >
                          <i className="fas fa-hand-holding me-1"></i> Surrender
                        </button>
                      </Link>
                    )}
                    {requisition.status === "Surrender Submitted" && (
                      <Link to={`/view-surrender/${requisition.requisitionID}`}>
                        <button
                          className="btn btn-outline-success btn-sm"
                          onClick={() => handleSurrender(requisition.requisitionID)}
                        >
                          <i className="fas fa-hand-holding me-1"></i> View Surrender
                        </button>
                      </Link>
                    )}
                  </div>
                </div>
                
                <div className="requisition-details" >
                  <div className="view-requisition-date-and-id" hidden>
                    <p><strong>Requisition Date:</strong> {formatDate(requisition.requisitionDate)}</p>
                    <p><strong>Requisition ID:</strong> {requisition.requisitionID}</p>
                  </div>
                  
                  <div className="staff-activity-container">
                    <div className="form-group-review-requisition">
                      <h3>Staff Details</h3>
                      <p><strong>Staff Name:</strong> {requisition.staffName}</p>
                      <p><strong>Staff Level:</strong> {requisition.staffLevel}</p>
                      <p><strong>Supervisor Name:</strong> {requisition.supervisorName}</p>
                    </div>

                    <div className="form-group-review-requisition">
                      <h3>Activity Details</h3>
                      <p><strong>Activity Duration:</strong> 
                        <span style={{marginLeft: '8px'}}>
                          {formatDate(requisition.from)} to {formatDate(requisition.to)}
                        </span>
                      </p>
                      <p><strong>Activity Name:</strong> {requisition.activityName}</p>
                      <p><strong>Activity Purpose:</strong> {requisition.activityPurpose}</p>
                      <p><strong>Target Client:</strong> {requisition.targetClient}</p>
                      <p><strong>Expected Impact:</strong> {requisition.expectedImpact}</p>
                      <p> <strong>District & AP:</strong> </p>
                      {requisition.districtAndAreaProgramPairs?.map((pair, idx) => (
                        <div key={idx}>
                          <p>
                            <li>{pair.district} - {pair.areaProgram}</li>
                          </p>
                        </div>
                      ))}
                      
                      {requisition.status === "Disapproved" && (
                        <p><strong>Reason:</strong> {requisition.reason}</p>
                      )}  
                    </div>
                  
                    <div className="form-group-review-requisition">
                      <h3>Project & Advance Details</h3>
                      <p><strong>Project Code:</strong> {requisition.projectCode}</p>
                      <p><strong>Budget Line Code:</strong> {requisition.budgetLineCode}</p>
                      <p><strong>Pay Mode:</strong> {requisition.payMode}</p>
                      <p><strong>Bank Name:</strong> {requisition.bankName}</p>
                      <p><strong>Branch:</strong> {requisition.branch}</p>
                      <p><strong>Account Number:</strong> {requisition.accountNumber}</p>
                      <p><strong>Phone Number:</strong> {requisition.phoneNumber}</p>
                    </div>
                  </div>
          
                <div className="details-group">
                {/* Separate cost drivers into blasting and other */}
                {(() => {
                  // Filter cost drivers based on whether they're blasting or other
                  const blastingDrivers = requisition.costDrivers?.filter(
                    driver => driver.costDriver?.toLowerCase().includes('blasting') || 
                              driver.customCostDriver?.toLowerCase().includes('blasting')
                  ) || [];
                  
                  const otherDrivers = requisition.costDrivers?.filter(
                    driver => !driver.costDriver?.toLowerCase().includes('blasting') && 
                              !driver.customCostDriver?.toLowerCase().includes('blasting')
                  ) || [];

                  return (
                    <>
                      <div className="details-group">
                        {/* Blasting Cost Drivers Section */}
                        <div id="blasting-div">
                          <h3 id="blasting-heading">Blasting Cost Drivers</h3> 
                        </div>

                        {requisition.blastingCostDrivers?.length > 0 ? (
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Cost Driver</th>
                                <th>Justification</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                                <th>Support Documents</th>
                              </tr>
                            </thead>
                            <tbody>
                              {requisition.blastingCostDrivers.map((driver, index) => {
                                const total = driver.total || 0;
                                return (
                                  <tr key={index}>
                                    <td>
                                      <strong>{index + 1}. </strong> {driver.costDriver || driver.customCostDriver}
                                    </td>
                                    <td>{driver.justification}</td>
                                    <td>{driver.quantity}</td>
                                    <td>{driver.unitPrice}</td>
                                    <td>{total.toLocaleString('en-US')}</td>
                                    <td>{driver.supportDocuments}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="4" style={{ textAlign: 'right' }}>
                                  <b>Blasting Total:</b>
                                </td>
                                <td>
                                  {requisition.blastingCostDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0).toLocaleString('en-US')}
                                </td>
                                <td></td>
                              </tr>
                            </tfoot>
                          </table>
                        ) : (
                          <p className="text-muted">No blasting cost drivers</p>
                        )}

                        {/* Other Cost Drivers Section */}
                        <div id="blasting-div">
                          <h3 id="blasting-heading">Other Cost Drivers</h3> 
                        </div>

                        {requisition.costDrivers?.length > 0 ? (
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Cost Driver</th>
                                <th>Justification</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                                <th>Support Documents</th>
                              </tr>
                            </thead>
                            <tbody>
                              {requisition.costDrivers.map((driver, index) => {
                                const total = driver.total || 0;
                                return (
                                  <tr key={index}>
                                    <td>
                                      <strong>{index + 1}. </strong> {driver.costDriver || driver.customCostDriver}
                                    </td>
                                    <td>{driver.justification}</td>
                                    <td>{driver.quantity}</td>
                                    <td>{driver.unitPrice}</td>
                                    <td>{total.toLocaleString('en-US')}</td>
                                    <td>{driver.supportDocuments}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="4" style={{ textAlign: 'right' }}>
                                  <b>Other Cost Total:</b>
                                </td>
                                <td>
                                  {requisition.costDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0).toLocaleString('en-US')}
                                </td>
                                <td></td>
                              </tr>
                            </tfoot>
                          </table>
                        ) : (
                          <p className="text-muted">No other cost drivers</p>
                        )}

                        {/* Grand Total - styled like ReviewRequisition's total summary */}
                        {((requisition.blastingCostDrivers?.length > 0) || (requisition.costDrivers?.length > 0)) && (
                          <div className="total-summary-section" style={{ marginTop: '20px' }}>
                            <div className="total-item">
                              <div className="total-item-label">Blasting Total</div>
                              <div className="total-item-value">
                                {requisition.blastingCostDrivers?.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0).toLocaleString('en-US')}
                              </div>
                            </div>
                            <div className="total-operator">+</div>
                            <div className="total-item">
                              <div className="total-item-label">Other Cost Drivers Total</div>
                              <div className="total-item-value">
                                {requisition.costDrivers?.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0).toLocaleString('en-US')}
                              </div>
                            </div>
                            <div className="total-operator">=</div>
                            <div className="grand-total-box">
                              <div className="grand-total-label">Grand Total</div>
                              <div className="grand-total-value">
                                {[...(requisition.blastingCostDrivers || []), ...(requisition.costDrivers || [])]
                                  .reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0)
                                  .toLocaleString('en-US')}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                     
                      {/* Overall Total */}
                      {requisition.costDrivers?.length > 0 && (
                        <div style={{ marginTop: '20px', textAlign: 'right', fontWeight: 'bold' }}>
                          Overall Total: {
                            requisition.costDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0).toLocaleString('en-US')
                          }
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>

                  <div className="signature-container">
                    <div className="signed-by-label">Signed by:</div>
                    {submitter?.signatureFilePath ? (
                      <img
                        src={`${process.env.REACT_APP_STATIC_BASE_URL}/${submitter.signatureFilePath}`}
                        alt={`${submitter.firstName} ${submitter.lastName}'s Signature`}
                        className="signature-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                    ) : null}
                    {!submitter?.signatureFilePath && (
                      <div className="no-signature">Signature not found</div>
                    )}
                    <div className="user-full-name">
                      {submitter ? `${submitter.firstName} ${submitter.lastName}` : requisition.staffName}
                    </div>
                    <br/>
                  </div>
                </div>
              </div>
            </div>

            <PopupModal
              isVisible={showHistory}
              onClose={() => setShowHistory(false)}
              title="Requisition History"
              titleStyle="modal-title"
              icon={faHistory}
              iconBorder="icon-circle"
            >
              <div className="timeline">
                {combinedHistory.map((entry, idx) => (
                  <div key={idx} className="timeline-entry">
                    <p>
                      <strong>Stage {entry.step}: </strong> 
                      <div className={`badge ${getStatusClass(entry.status)}`}>
                        {entry.status || 'Unknown'}
                      </div>
                    </p>
                  </div>
                ))}
                <hr/>
              </div>
            </PopupModal>
          </div>
          {/* End of container-fluid */}
        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}
      </div>
      {/* End of Content Wrapper */}
    </div>
  );
};

export default ViewRequisition;